import { type Config } from '@pkgs/components/providers/AppContextProvider';

export const CONFIG: Config = {
  mapTilerApiKey: process.env.NEXT_PUBLIC_MAP_TILER_API_KEY,
  friendlyCaptchaSiteKey: process.env.NEXT_PUBLIC_FRIENDLY_CAPTCHA_SITE_KEY ?? '',
  searchAlertBaseUrl: (process.env.NEXT_PUBLIC_VERCEL_DOMAIN ?? '') + '/api/',
  ...(process.env.NEXT_PUBLIC_VERCEL_PROTECTION_BYPASS_TOKEN && {
    vercelProtectionBypassToken: process.env.NEXT_PUBLIC_VERCEL_PROTECTION_BYPASS_TOKEN,
  }),
};
